<template>
  <div class="customerLeft">
    <div>
      <Input
        v-model="cvalue"
        @on-change="changeSearch"
        prefix="ios-search"
        placeholder="搜索"
        style="width: 183px"
      />
      <div class="cust-list">
        <template v-for="(idx, key) in clist">
          <div class="cust-list-item" :key="key">
            <div class="title u-flex u-row-between">
              <div>{{ idx.letter }}</div>
              <div class="pot" @click="collapseHandle(idx)">
                <Icon
                  v-if="idx.bo"
                  type="ios-arrow-up"
                  color="#a8a8a8"
                  size="20"
                />
                <Icon v-else size="20" type="ios-arrow-down" color="#a8a8a8" />
              </div>
            </div>
            <div class="item-ul" v-if="idx.bo">
              <div
                class="item-li line-1 pot"
                @click="checkItemHandle(index1)"
                v-for="(index1, key1) in idx.data"
                :class="{ 'item-li-check': index1.bo }"
                :key="key1"
              >
                {{ index1.lable }}
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    nameList: {},
  },
  watch: {
    nameList: {
      deep: true,
      immediate: true,
      handler: function (params) {
     
        if (params && params.length > 0) {
          this.copylist(this.$c.deepClone(this.nameList));
        } else {
          this.clist = [];
        }
      },
    },
    item: {
      deep: true,
      handler: function (newvlaue, oldvalue) {
        if (oldvalue) {
          oldvalue.bo = false;
        }
      },
    },
  },
  data() {
    return {
      clist: [],
      item: {},
      cvalue: "",
    };
  },
  methods: {
    collapseHandle(row) {
      this.clist = this.clist.map((item) => {
        if (item.letter == row.letter) {
          item.bo = !item.bo;
        } else {
          item.bo = false;
        }

        return item;
      });

   
    },
    checkItemHandle(row) {
      row.bo = true;
      this.item = row;
      this.$emit("change", { row });
    },
    copylist(list) {
      let clist = list.map((e) => {
        e.data = e.data.map((e1) => {
          e1.bo = false;
          return e1;
        });
        return e;
      });
      this.clist = clist;
      this.item = clist[0].data[0];
      this.item.bo = true;
      
    },
    changeSearch(row) {
      this.$emit("cinput", { value: this.cvalue });
    },
  },
};
</script>
<style lang="less" >
.customerLeft {
  width: 216px;
  min-height: 460px;
  display: flex;
  align-content: center;
  max-height: calc(~"100vh - 150px");
  .ivu-input-wrapper {
    .ivu-input {
      border: none;
      border-bottom: 1px solid #dcdee2;
      border-radius: 0;
      box-shadow: none !important;
    }
  }

  .cust-list {
    padding-top: 16px;
    height: calc(~"100% - 32px");
    overflow: auto;
    overflow-x: hidden;
    padding-right: 22px;
    .cust-list-item {
      width: 183px;
      margin-bottom: 20px;
      .title {
        font-size: 11px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #262626;
        padding-bottom: 8px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      }
      .item-ul {
        margin-top: 16px;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        .item-li {
          width: 183px;
          padding: 8px;
        }
      }
    }
  }
  .item-li-check {
    background: #f3f3f3;
  }
}
</style>